<template>
  <div class="block services">
    <div class="block-title center">
      <h2>Выберите необходимые услуги</h2>
    </div>
    <ul class="services-list">
      <li v-for="service in showedServices" :key="service.id" class="service-item">
        <div class="info" :class="{ disabled: !service.isAvailable }">
          <div class="label" @click="service.isAvailable ? localToggleService(service) : null">
            <input
              :disabled="!service.isAvailable"
              type="checkbox"
              :checked="addedServicesID.includes(service.id)"
            />
            <span>{{ service.name }}</span>
          </div>
          <div class="price">
            <span>{{ service.price }} &#x20bd;</span>
            <i
              class="icon-tooltip"
              v-tooltip.top-center="{
                content: service.description,
                trigger: 'click hover',
              }"
            ></i>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import { GENERAL_STORE } from '@apps/order-form/src/store'
import ORDER_SERVICE_CODE from '@constants/orderServiceCode'

export default {
  name: 'ExtraServices',
  computed: {
    ...mapState(GENERAL_STORE, ['services', 'base', 'form']),
    ...mapGetters(GENERAL_STORE, ['showedServices', 'addedServicesID', 'managedServices']),
  },
  methods: {
    ...mapMutations(GENERAL_STORE, [
      'toggleService',
      'setManualNarrowInterval',
      'setManualOtherDay',
    ]),
    ...mapActions(GENERAL_STORE, ['calculatePrice']),

    localToggleService(service) {
      if (this.base.isAdmin) {
        // eslint-disable-next-line default-case
        switch (service.id) {
          case ORDER_SERVICE_CODE.NarrowInterval: {
            this.setManualNarrowInterval(true)
            break
          }

          case ORDER_SERVICE_CODE.OtherDay: {
            this.setManualOtherDay(true)
            break
          }
        }
      }

      this.toggleService(service.id)

      this.calculatePrice()
    },
  },
}
</script>

<style lang="scss" scoped>
.info.disabled {
  opacity: 0.4;

  .label {
    cursor: default;

    input {
      cursor: default !important;
    }

    span {
      cursor: default;
    }
  }
}
</style>
